import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const IMEIExtendedWarrantyModel = {
    searchIMEIExtendedWarranty: (params) => {
        const qs = modelBaseV2.toQueryString(params)
        return modelBaseV2.get(`/api/model/extendedwarranty?${qs}`);
    },
    downloadIMEIExtendedWarrantyExcelTemplate: (fileName = "IMEIExtendedWarrantyTemplate") => {

        return modelBaseV2.getDownload("/api/model/extendedwarranty/upload", {}, fileName);
    },
    uploadExcelIMEIExtendedWarranty: (file) => {
        let body = new FormData();
        body.append('file', file);

        return modelBaseV2.postDownload('/api/model/extendedwarranty/upload', { body }, `IMEI_Extended_Warranty_Upload_Result_${moment().format('YYYYMMDDhhmm')}.xlsx`);
    }
}

export default IMEIExtendedWarrantyModel;  